import { formatSource } from "@validator/schema";

import { StudyContextData, SubmissionContextData } from "@/context/AppContext";

import { SecondaryButton } from "@shared/components/Button";

import { SubmissionForm } from "@/views/study/components/submission/SubmissionForm";

import { T } from "@/components/i18n";
import { ValidDataAlert } from "@/components/submission/Alerts";

interface ValidatedFlowProps {
  studyContext: StudyContextData;
  submissionContext: SubmissionContextData;
}

export function ValidatedFlow({ studyContext, submissionContext }: ValidatedFlowProps) {
  const { validation, resetValidation } = submissionContext;
  const { study } = studyContext;

  if (!study || validation?.status !== "accepted") {
    return null;
  }

  const source = formatSource(validation.result.data.source);

  return (
    <SubmissionForm submissionContext={submissionContext} studyContext={studyContext}>
      <ValidDataAlert
        result={validation.result}
        text={<T i18nKey="view.submission.flow.validated.alert" values={{ source }} />}
      >
        <SecondaryButton variant="secondary" round highlight onClick={resetValidation}>
          Try another file
        </SecondaryButton>
      </ValidDataAlert>
    </SubmissionForm>
  );
}
